// extracted by mini-css-extract-plugin
export var icon = "_6h-1";
export var subtext = "_6h-0";